import { memo } from 'react'
import { BookMarked, TextSelect } from 'lucide-react'
import type { ChatAttachment, FinalizedAttachment } from '../../../../types'
import { FadingScrollable } from '../../../elements/FadingScrollable'
import { PreviewableContext } from '../../input/context/previewable-context'
import { AttachmentStub } from '../attachment-stub'
import { useRemoveAttachment } from '../hooks/use-remove-attachment'
import { scrollableAreaClassName, scrollablePreviewClassName } from '../styles'
import type { AttachmentPillProps } from '../types'

export const SelectedText = memo((attachment: AttachmentPillProps) => {
  const onRemove = useRemoveAttachment(attachment)

  // check if this is rag knowledge attachment for custom display
  const selectedText = attachment.attachment as Extract<FinalizedAttachment, { type: 'selectedText' }>
  const isRagKnowledge = selectedText?.ragProcessed === true

  return (
    <PreviewableContext preview={<SelectedTextPreview {...attachment} />}>
      <AttachmentStub
        label={isRagKnowledge ? 'Knowledge' : 'Text'}
        icon={isRagKnowledge ? <BookMarked size={16} /> : <TextSelect size={16} />}
        onRemove={onRemove}
      />
    </PreviewableContext>
  )
})
SelectedText.displayName = 'SelectedText'

const SelectedTextPreview = memo((attachment: ChatAttachment) => {
  const selectedText = attachment.attachment as Extract<FinalizedAttachment, { type: 'selectedText' }>
  return (
    <div className={scrollablePreviewClassName}>
      <FadingScrollable className={scrollableAreaClassName} onClick={(e) => e.stopPropagation()}>
        {selectedText.text}
      </FadingScrollable>
    </div>
  )
})
SelectedTextPreview.displayName = 'SelectedTextPreview'
